module.exports = __webpack_public_path__ + "img/clock-icon.16718423.svg";